import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useFreemiumExpiresDate, useFreemiumSubscriptionDays, useIsFreemium } from 'reactApp/hooks/useFreemium';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { FreemiumModalState, getFreemiumModalState } from 'reactApp/ui/Freemium/freemiumModals.helpers';
import { renderFreemiumEndedModal } from 'reactApp/ui/FreemiumEndedModal';
import { renderFreemiumEndingModal } from 'reactApp/ui/FreemiumEndingModal';

export const useFreemiumModals = (): void => {
    const isFreemium = useIsFreemium();
    const freemiumDays = useFreemiumSubscriptionDays();
    const expiresDate = useFreemiumExpiresDate();
    const isOverquota = useSelector(UserQuotaSelectors.isOverquota);
    const isQuotaLoaded = useSelector(UserQuotaSelectors.isQuotaLoaded);

    useEffect(() => {
        if (!isQuotaLoaded) {
            return;
        }

        if (!isFreemium || isOverquota) {
            return;
        }

        const modalState = getFreemiumModalState(freemiumDays, expiresDate);

        if (modalState === FreemiumModalState.ENDING) {
            if (expiresDate) {
                renderFreemiumEndingModal({ expiresDate });
            }
        } else if (modalState === FreemiumModalState.ENDED) {
            renderFreemiumEndedModal({ expiresDate });
        }
    }, [isFreemium, freemiumDays, expiresDate, isOverquota, isQuotaLoaded]);
};
